import { Box, Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses, LinearProgressProps } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 12,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundImage: 'linear-gradient(90deg, #e01cd5, #1CB5E0)',
        backgroundSize: '200% auto',
        animation: 'gradient-bar 2s linear infinite',
        ...theme.applyStyles('dark', {
            backgroundImage: 'linear-gradient(90deg, #308fe8, #1a90ff)',
        }),
    }
}));

export const BorderLinearProgress = (props: LinearProgressProps & { value: number }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', width: "100%" }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <CustomLinearProgress {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary' }}
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
};
